import { useParams } from "react-router-dom"
import { AESDecrypt } from "../../encrypt-util"
import InvoiceChanges from "../../app/features/blRequestInstruction/components/InvoiceChanges"
import ExportInvoiceChanges from "../../app/features/blRequestInstruction/components/ExportInvoiceChanges"
import PickUpInstruction from "../../app/features/blRequestInstruction/components/PickUpInstruction"
import CarrierHaulage from "../../app/features/blRequestInstruction/components/CarrierHaulage"
import NominateAgent from "../../app/features/dashboard/components/NominateAgent"
import ReleaseInstruction from "../../app/features/blRequestInstruction/components/ReleaseInstruction"
import Coreor from "../../app/features/coreor/Coreor"
import OblDetails from "../../app/common/components/OblDetails"
import BlanketDelegation from "../../app/features/dashboard/components/BlanketDelegation"
import OverstayExtensionRequest from "../../app/features/blRequestInstruction/components/OverstayExtensionRequest"
import DOExtenstion from "../../app/features/blRequestInstruction/components/DOExtension/DoExtension"
import Refund from "../../app/features/refund/Refund"
import InvoiceRequest from "../../app/features/invoiceRequest/InvoiceRequest"
import ContainerDropOff from "../../app/features/containerDropOff/ContainerDropOff"
// import EBLTransfer from "../../app/features/ebl/components/EBLTransfer"

const map = {
    802 : <InvoiceChanges />,
    902 : <ExportInvoiceChanges />,
    808 : <PickUpInstruction />,
    801 : <CarrierHaulage />,
    811 : <NominateAgent />,
    805 : <NominateAgent />,
    812 : <NominateAgent />,
    814 : <NominateAgent />,
    813 : <NominateAgent />,
    815 : <NominateAgent />,
    804 : <ReleaseInstruction />,
    820 : <DOExtenstion />,
    205 : <Coreor />,
    710 : <OblDetails />,
    715 : <OblDetails />,
    705 : <OblDetails />,
    720 : <OblDetails />,
    201 : <OblDetails />,
    810 : <BlanketDelegation />,
    816 : <OverstayExtensionRequest />,
    821: <Refund />,
    822: <InvoiceRequest />,
    824: <ContainerDropOff />
    // 990 : <EBLTransfer/>
}
const InstructionMapper =()=>{
    const {encrypt} = useParams()
    const instruction = AESDecrypt(encrypt)
    // const instruction = 990 

    return map[instruction]
}

export default InstructionMapper
